import { about, credentials, profile, socials } from '../data/content';
import { SectionHead, SocialIcon, delay } from './primitives';

export function About() {
  return (
    <section className="section" id="about" aria-labelledby="about-title">
      <div className="container">
        <SectionHead title="About Me" id="about-title" />

        <div className="about">
          <div data-reveal>
            <img
              className="about__portrait"
              src={`${import.meta.env.BASE_URL}portrait.jpg`}
              alt="Palbir Minhas at his University of Washington graduation"
              width={800}
              height={800}
              loading="lazy"
            />

            <ul className="socials">
              {socials.map((social) => (
                <li key={social.id}>
                  <a href={social.href} aria-label={social.label} rel="noreferrer">
                    <SocialIcon name={social.id} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="about__body" data-reveal style={delay(120)}>
            <h3 className="about__hello">Hello world!</h3>
            {about.map((paragraph) => (
              <p key={paragraph.slice(0, 24)}>{paragraph}</p>
            ))}

            <div className="facts">
              {credentials.map((credential) => (
                <article className="fact" key={credential.id}>
                  <p className="fact__when">{credential.period}</p>
                  <h4 className="fact__what">{credential.award}</h4>
                  <p className="fact__where">{credential.school}</p>
                  <p className="fact__where">{credential.detail}</p>
                </article>
              ))}
            </div>

            <p className="fact__when" style={{ marginTop: '1.5rem' }}>
              {profile.availability}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
